import layout from '@/components/common/layout';
import clessonList from '../views/clesson/list';
import clessonStudent from '../views/clesson/student';
import clessonCreate from "../views/clesson/create";

export default [
    {
        path: '/clesson',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "课程列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'class_list',// 子选项
                    }
                },
                component: clessonList,
            },
            {
                path: 'student',
                meta: {
                    metaInfo: {
                        title: "课程列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'cstudent_list',// 子选项
                    }
                },
                component: clessonStudent,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑课程",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'class_list',// 子选项
                    }
                },
                component: clessonCreate,
            },
        ]
    },
];
